const twoPlans = [
  { value: "ESLELD", label: "ESL/ELD" },
  { value: "IEP", label: "IEP" },
  { value: "NA", label: "N/A" },
  { value: "", label: "x" },
];
const threePlans = [
  { value: "ESLELD", label: "ESL/ELD" },
  { value: "IEP", label: "IEP" },
  { value: "French", label: "French" },
  { value: "", label: "x" },
];
const fourPlans = [
  { value: "ESLELD", label: "ESL/ELD" },
  { value: "IEP", label: "IEP" },
  { value: "French", label: "French" },
  { value: "NA", label: "N/A" },
  { value: "", label: "x" },
];
const sixPlans = [
  { value: "ESLELD", label: "ESL/ELD" },
  { value: "IEP", label: "IEP" },
  { value: "Core", label: "Core" },
  { value: "Immersion", label: "Immersion" },
  { value: "Extended", label: "Extended" },
  { value: "NA", label: "N/A" },
  { value: "", label: "x" },
];
const threeResults = [
  { value: "PWD", label: "Progressing With Difficulty" }, // Progressing With Difficulty
  { value: "PW", label: "Progressing Well" }, // Progressing Well
  { value: "PVW", label: "Progressing Very Well" }, // Progressing Very Well
  { value: "", label: "x" },
];
const selectItems = [
  { value: "E", label: "E" },
  { value: "G", label: "G" },
  { value: "S", label: "S" },
  { value: "N", label: "N" },
  { value: "", label: "x" },
];

export { twoPlans, threePlans, fourPlans, sixPlans, threeResults, selectItems };
